import { lazy } from 'react';

import type { TDashboardRouter } from './types/DashboardRouter.types';
import type { RouteConfig } from '@/router/route.types';
import type { TPage } from '@/router/type';

import { composeRootPath } from '@/router/utils';

const PAGES: Record<TDashboardRouter, TPage> = {
  DASHBOARD: {
    id: 'dashboard',
    name: 'Dashboard',
    path: composeRootPath('/dashboard'),
    hidden: true,
  },
};

const ROUTES: Record<TDashboardRouter, RouteConfig> = {
  DASHBOARD: {
    id: PAGES.DASHBOARD.id,
    name: PAGES.DASHBOARD.name,
    path: PAGES.DASHBOARD.path,
    component: lazy(() => import('@features/Dashboard/pages/Dashboard.page')),
  },
};

export default {
  PAGES,
  ROUTES,
};
